import { render, staticRenderFns } from "./DrugReviewRequested.vue?vue&type=template&id=3783e2ec&scoped=true"
import script from "./DrugReviewRequested.vue?vue&type=script&lang=js"
export * from "./DrugReviewRequested.vue?vue&type=script&lang=js"
import style0 from "./DrugReviewRequested.vue?vue&type=style&index=0&id=3783e2ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3783e2ec",
  null
  
)

export default component.exports